import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell,
} from 'recharts';
import type { ChartPoint } from '../../hooks/useAnalytics';

const COLORS = ['#089d3c', '#61ae5c', '#abce9e', '#cadfc0', '#e0edd0'];

interface SpeciesBarChartProps {
  data: ChartPoint[];
  drillLabel?: string | null;
  onBack?: () => void;
}

export const SpeciesBarChart = ({ data, drillLabel, onBack }: SpeciesBarChartProps) => (
  <div className="bg-white rounded-lg border border-slate-200 p-4">
    <div className="flex items-center justify-between mb-4 gap-2">
      <h3 className="text-sm font-semibold text-slate-700">
        {drillLabel ? `Productive Types — ${drillLabel}` : 'Conversations by Species'}
      </h3>
      {drillLabel && (
        <button
          onClick={onBack}
          className="text-xs text-emerald-600 hover:text-emerald-700 shrink-0"
        >
          ← All species
        </button>
      )}
    </div>
    {data.length === 0 ? (
      <p className="text-xs text-slate-400 py-8 text-center">No data</p>
    ) : (
      <ResponsiveContainer width="100%" height={220}>
        <BarChart data={data} margin={{ top: 4, right: 12, left: -8, bottom: 0 }}>
          <XAxis dataKey="name" tick={{ fontSize: 11 }} />
          <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
          <Tooltip
            contentStyle={{ fontSize: 12 }}
            formatter={(v) => [v, 'Conversations']}
          />
          <Bar dataKey="count" radius={[3, 3, 0, 0]}>
            {data.map((_, i) => (
              <Cell key={i} fill={COLORS[i % COLORS.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    )}
  </div>
);
